import React from 'react';
import PropTypes from 'prop-types';

import {
  primary100, primary200, danger100, danger200,
} from 'components/new_ui/Colors';
import Table from 'components/new_ui/Table';
import { useContext } from 'components/Managers/Members/Context';

export default function Preview({
  members, loading, selectedMembers, setSelectedMembers,
}) {
  const { state: { finchOptions } } = useContext();

  const columns = [
    {
      name: 'First Name',
      selector: (row) => row.first_name,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Last Name',
      selector: (row) => row.last_name,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Status',
      selector: (row) => row.status,
      sortable: true,
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => finchOptions.synchImport && row.status === 'New',
      style: {
        backgroundColor: primary100,
      },
    },
    {
      when: (row) => finchOptions.synchImport && row.status === 'New' && selectedMembers.includes(row.id),
      style: {
        backgroundColor: primary200,
      },
    },
    {
      when: (row) => finchOptions.synchImport && row.status === 'Terminated',
      style: {
        backgroundColor: danger100,
      },
    },
    {
      when: (row) => finchOptions.synchImport && row.status === 'Terminated' && selectedMembers.includes(row.id),
      style: {
        backgroundColor: danger200,
      },
    },
  ];

  return (
    <div className="content">
      <section>
        <h3>Member Directory</h3>

        <Table
          title=" "
          columns={columns}
          data={members}
          loading={loading}
          conditionalRowStyles={conditionalRowStyles}
          selectableRowSelected={(_row) => true}
          afterSelect={(selectedRows) => setSelectedMembers(selectedRows)}
        />
      </section>
    </div>
  );
}

Preview.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool.isRequired,
  selectedMembers: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedMembers: PropTypes.func.isRequired,
};
